import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useMemo } from 'react';

import { useGetMailClassesQuery } from '@api/mailClass';
import { AnnotationType } from '@apiContract';

import { MappedAnnotations } from './types';

type Props = {
  onChange: (annotationType: AnnotationType, value: string) => void;
  annotations: MappedAnnotations;
};

const Mail = ({ onChange, annotations }: Props) => {
  const { data: mailClasses = [] } = useGetMailClassesQuery();

  const mailClassOptions = useMemo(
    () =>
      mailClasses.map((mailClass) => ({
        value: mailClass.name,
        label: mailClass.name,
      })),
    [mailClasses],
  );

  const handleChange = (event: SelectChangeEvent) => {
    onChange(AnnotationType.MailClass, event.target.value);
  };

  return (
    <>
      <Typography variant="subtitle2">Mail Class</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Mail Class</InputLabel>
        <Select
          value={(annotations[AnnotationType.MailClass] || '').toString()}
          label="Select Mail Class"
          onChange={handleChange}
        >
          {mailClassOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default Mail;
